import Vue from "vue";

let vue = new Vue();
// console.log("vue", vue);

export function axiosApi(api, param, query) {
  // debugger;
  let NULL = null;
  return vue
    .$http({
      url: api.url,
      method: api.method,
      data: param,
      params: query,
      timeout: 1000 * 120,
    })
    .then(data => {
      return { data: data, err: NULL };
    })
    .catch(err => {
      console.log("axiosApi err", api.url, err);
      return { data: NULL, err };
    });
}



// WEBPACK FOOTER //
// ./src/common/js/api.js